module.exports = __webpack_public_path__ + "static/img/thumb-certified-family-forest-lands.afe5772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-certified-family-forest-lands.png
// module id = 84
// module chunks = 0